import React from 'react';
import '../../styles/Header.css';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

const pathToTitle = {
  '/app/dashboard': 'Tableau de bord',
  '/app/accounts': 'Comptes',
  '/app/opportunities': 'Opportunités',
  '/app/quotes': 'Devis',
  '/app/bills': 'Factures',
  '/app/products': 'Produits',
  '/app/settings': 'Paramètres',
};

  const getTitle = () => {
    return pathToTitle[location.pathname] || 'Q&B';
  };

  return (
    <header className="header">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h1 className="title">{getTitle()}</h1>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
